"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsBookingByOwn = exports.getIsBookingByOperator = void 0;
var _ramda = require("ramda");
var BOOKING_TYPES = {
  OPERATOR: 'operator',
  OWN: 'own',
  COMBINED: 'combined'
};
var getIsBookingByOwn = exports.getIsBookingByOwn = function getIsBookingByOwn(bookingType) {
  return (0, _ramda.or)(bookingType === BOOKING_TYPES.OWN, bookingType === BOOKING_TYPES.COMBINED);
};
var getIsBookingByOperator = exports.getIsBookingByOperator = function getIsBookingByOperator(bookingType) {
  return (0, _ramda.or)(bookingType === BOOKING_TYPES.OPERATOR, bookingType === BOOKING_TYPES.COMBINED);
};